import toLine from './toLine'
import parentNameColumnMerge from './parentNameColumnMerge'
import selectFilter from './selectFilter'
import dealObjectValue from './dealObjectValue'

export default {
  ...toLine,
  ...parentNameColumnMerge,
  ...selectFilter,
  ...dealObjectValue
}
